import React from 'react';
import { getHistoryBonusDisplay } from './historyBonus.display.js';

export default function HistoryBonus({ bonus, status }) {
  const display = getHistoryBonusDisplay(bonus, status);
  if (!display) return null;
  return <small title={display.title} data-history-bonus="true"
    style={{ display: 'block', marginTop: 2, fontSize: 11, fontWeight: 500, lineHeight: 1.35, whiteSpace: 'nowrap', color: 'inherit', opacity: 0.8 }}>
    {display.label}
  </small>;
}
